// @ts-nocheck
/**
 * defaultRenderers.ts — Template V2 M3 Default Renderer Registry Factory
 *
 * createDefaultRegistry() constructs a RendererRegistry pre-populated with
 * all M3 component type renderers. Call this once at app bootstrap or
 * RenderService initialization.
 *
 * Individual renderers are exported so callers can compose custom registries
 * (e.g. a test double that overrides only one type).
 */

import { RendererRegistry } from './RendererRegistry';
import {
    BUTTON_RENDERER,
    DRAG_HANDLE_RENDERER,
    GROUP_RENDERER,
    ICON_RENDERER,
    LINE_RENDERER,
    SPACER_RENDERER,
} from './compositionRenderers';
import { ENUM_RENDERER } from './enumRenderer';
import { STRING_SELECT_RENDERER } from './stringSelectRenderer';
import { HTML_RENDERER } from './htmlRenderer';
import {
    COLOR_RENDERER,
    IMAGE_RENDERER,
    RATING_RENDERER,
    SVG_RENDERER,
} from './mediaRenderers';
import { QR_CODE_RENDERER } from './qrCodeRenderer';
import { TABLE_RENDERER } from './tableRenderer';
import { CHART_RENDERER } from './chartRenderer';
import { LIST_VIEW_RENDERER } from './listViewRenderer';
import { SLIDER_RENDERER } from './sliderRenderer';
import { TIMER_DISPLAY_RENDERER } from './timerDisplayRenderer';
import {
    BOOLEAN_RENDERER,
    DATE_RENDERER,
    NUMBER_RENDERER,
    TEXT_RENDERER,
} from './primitiveRenderers';

export {
    BOOLEAN_RENDERER,
    BUTTON_RENDERER,
    CHART_RENDERER,
    COLOR_RENDERER,
    DATE_RENDERER,
    DRAG_HANDLE_RENDERER,
    ENUM_RENDERER,
    STRING_SELECT_RENDERER,
    GROUP_RENDERER,
    ICON_RENDERER,
    IMAGE_RENDERER,
    HTML_RENDERER,
    LINE_RENDERER,
    LIST_VIEW_RENDERER,
    NUMBER_RENDERER,
    QR_CODE_RENDERER,
    RATING_RENDERER,
    SLIDER_RENDERER,
    SPACER_RENDERER,
    SVG_RENDERER,
    TABLE_RENDERER,
    TEXT_RENDERER,
    TIMER_DISPLAY_RENDERER,
};

/**
 * Returns a RendererRegistry with all M3 component renderers registered.
 * Creates a fresh instance on every call (no shared mutable state).
 */
export function createDefaultRegistry(): RendererRegistry {
  const registry = new RendererRegistry();
  registry.register(TEXT_RENDERER);
  registry.register(NUMBER_RENDERER);
  registry.register(BOOLEAN_RENDERER);
  registry.register(DATE_RENDERER);
  registry.register(ENUM_RENDERER);
  registry.register(STRING_SELECT_RENDERER);
  registry.register(IMAGE_RENDERER);
  registry.register(SVG_RENDERER);
  registry.register(HTML_RENDERER);
  registry.register(QR_CODE_RENDERER);
  registry.register(RATING_RENDERER);
  registry.register(COLOR_RENDERER);
  registry.register(SLIDER_RENDERER);
  registry.register(TIMER_DISPLAY_RENDERER);
  registry.register(GROUP_RENDERER);
  registry.register(BUTTON_RENDERER);
  registry.register(ICON_RENDERER);
  registry.register(SPACER_RENDERER);
  registry.register(DRAG_HANDLE_RENDERER);
  registry.register(LINE_RENDERER);
  registry.register(TABLE_RENDERER);
  registry.register(CHART_RENDERER);
  registry.register(LIST_VIEW_RENDERER);
  return registry;
}
